import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { initialiseSentry } from './utils/sentry'

// Config
import SubmissionForm from '@content/Submission/SubmissionForm'
import SubmissionTracker from '@content/Submission/SubmissionTracker'
import SubmissionAdditionalDetails from '@content/Submission/SubmissionAdditionalDetails'
import config from '@config/index'

// Components
import Wrapper from '@app/components/Wrapper'

import './Index.scss'

// Global Scripts
import '@app/dependencies/loqate.js'

initialiseSentry()

const claimForm = document.getElementById('claimForm')
const claimTracker = document.getElementById('claimTracker')
const claimAdditionalDetails = document.getElementById('claimAdditionalDetails')

claimForm && ReactDOM.render(<Wrapper config={{ ...SubmissionForm, ...config.campaign }} />, claimForm)
claimTracker && ReactDOM.render(<Wrapper config={{ ...SubmissionTracker, ...config.campaign }} />, claimTracker)
claimAdditionalDetails &&
  ReactDOM.render(<Wrapper config={{ ...SubmissionAdditionalDetails, ...config.campaign }} />, claimAdditionalDetails)
